"use client"

import { useEffect, useRef, useState } from 'react'

import { loadRecaptchaV2Script } from '@/lib/recaptcha-script'

type Props = {
  siteKey: string
  onChange: (token: string | null) => void
  className?: string
}

export function RecaptchaWidget({ siteKey, onChange, className = '' }: Props) {
  const containerRef = useRef<HTMLDivElement>(null)
  const widgetIdRef = useRef<number | null>(null)
  const onChangeRef = useRef(onChange)
  const [loadError, setLoadError] = useState<string | null>(null)

  useEffect(() => {
    onChangeRef.current = onChange
  }, [onChange])

  useEffect(() => {
    let cancelled = false
    setLoadError(null)

    loadRecaptchaV2Script()
      .then(() => {
        if (cancelled || !containerRef.current || !window.grecaptcha?.render) return
        if (widgetIdRef.current !== null) {
          try {
            window.grecaptcha.reset(widgetIdRef.current)
          } catch {
            widgetIdRef.current = null
          }
        }
        if (widgetIdRef.current === null) {
          widgetIdRef.current = window.grecaptcha.render(containerRef.current, {
            sitekey: siteKey,
            callback: (token) => onChangeRef.current(token),
            'expired-callback': () => onChangeRef.current(null),
            'error-callback': () => onChangeRef.current(null),
          })
        }
      })
      .catch(() => {
        if (!cancelled) {
          setLoadError('reCAPTCHA yüklenemedi.')
          onChangeRef.current(null)
        }
      })

    return () => {
      cancelled = true
    }
  }, [siteKey])

  return (
    <div className={className}>
      <div ref={containerRef} className="min-h-[78px]" />
      {loadError ? <p className="mt-2 text-center text-xs text-destructive">{loadError}</p> : null}
    </div>
  )
}
